import { supabase } from "@/project/integrations/supabase/client";
import MotishaService from "@/services/APIs/MotishaService";

const resolveDataList = (data: any) => {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.results)) return data.results;
  return [];
};

export const orgsQuery = {
  queryKey: ["organizations"],
  queryFn: async () => {
    const { data, error } = await supabase
      .from("organizations")
      .select("*")
      .order("display_seq")
      .order("short_name");
    if (error) {throw error;}
    return data;
  },
};

export const companiesQuery = {
  queryKey: ["companies"],
  queryFn: async () => {
    const data = await MotishaService.getCompanies();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
      contact_number: item.contact,
      visiting_day: item.visiting,
      visiting_time: "",
    }));
  },
};


export const categoriesQuery = {
  queryKey: ["categories"],
  queryFn: async () => {
    const data = await MotishaService.getCategories();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
    }));
  },
};

export const settingsQuery = {
  queryKey: ["settings"],
  queryFn: async () => {
    const { data, error } = await supabase.from("app_settings").select("*");
    if (error) {throw error;}
    const map: Record<string, string> = {};
    for (const row of data ?? []) {map[row.key] = row.value ?? "";}
    return map;
  },
};

export const checklistQuery = {
  queryKey: ["checklist"],
  queryFn: async () => {
    const { data, error } = await supabase
      .from("document_checklist")
      .select("*")
      .order("sort_order");
    if (error) {throw error;}
    return data;
  },
};

export const APPLICATION_SELECT =
  "*, assistance_categories(name), families(ration_card_no, area, city)";

export const banksQuery = {
  queryKey: ["bank_master"],
  queryFn: async () => {
    const data = await MotishaService.getBanks();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      name: item.bank_name,
      active: item.is_active,
    }));
  },
};

export const subcategoriesQuery = {
  queryKey: ["assistance_subcategories"],
  queryFn: async () => {
    const data = await MotishaService.getSubcategories();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
    }));
  },
};

export const districtsQuery = {
  queryKey: ["districts"],
  queryFn: async () => {
    const data = await MotishaService.getDistricts();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
    }));
  },
};

export const citiesQuery = {
  queryKey: ["cities"],
  queryFn: async () => {
    const data = await MotishaService.getCities();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
    }));
  },
};

export const areasQuery = {
  queryKey: ["areas"],
  queryFn: async () => {
    const data = await MotishaService.getAreas();
    const list = resolveDataList(data);
    return list.map((item: any) => ({
      ...item,
      active: item.is_active,
    }));
  },
};

